<template>
  <v-container grid-list-lg>
    <v-layout row wrap justify-center align-center>
      <v-flex xl8 lg10 md12 xs12>
        <v-card id="executives" flat class="transparent" height="100"></v-card>
        <div class="text-xs-center">
          <h1 class="mb-3 primary--text">
            {{ trans('Meet Our Executives') }}
          </h1>
        </div>
        <v-card flat class="transparent" height="50"></v-card>

        <!-- ceo -->
        <v-layout row wrap>
          <v-flex sm4 xs12>
            <v-card>
              <v-img @contextmenu.prevent="preventRightClick" aspect-ratio="1" :src="executives.suhaimi"></v-img>
            </v-card>
          </v-flex>
          <v-flex offset-sm1 sm7 xs12>
            <h3 class="mb-1">{{ __('Suhaimi Salleh') }}</h3>
            <p><strong>{{ __('President & Chief Executive Officer') }}</strong></p>

            <br>
            <p>{{ __('Suhaimi Salleh is the Founder & CEO of SSA Group, a group of companies established in 1986, providing professional services in management consulting, training, audit, accounting and estate planning. Two of its member companies, SSA Academy and SSA Culinary Institute, are approved training providers for the SkillsFuture Singapore (SSG) Workforce Skills Qualifications (WSQ) programmes and has trained more than 200,000 workers.') }}</p>

            <p>{{ __('Suhaimi has more than 40 years of post-graduate experience in management, consulting and corporate training. His expertise includes audit, finance, productivity and human capital management in a broad range of industries in Singapore, Malaysia, Indonesia, Philippines and Brunei. He has also been invited to speak at major conferences in Singapore, Malaysia, Indonesia and Saudi Arabia.') }}</p>

            <p>{{ __('Suhaimi is also a registered Asian Productivity Organisation (APO) Technical Expert on Productivity Management and Human Resource Development. He has been instrumental in introducing total quality management (TQM) and productivity improvement initiatives to companies and non-profit organisations in Singapore, Malaysia and Brunei. He is also a trainer in productivity, quality, finance and accounting and an accredited consultant for Enterprise Singapore.') }}</p>

            <p>{{ __('Suhaimi has won multiple awards for serving as an active community leader throughout his career and is currently the President of PMBM Scholarship Fund Board (LBKM) and Audit Committee Chairman of SG Enable. He has also served, among others, as a member of the Board of Governors of Temasek Polytechnic, the Council of Ngee Ann Polytechnic, Public Transport Council and the Charity Council.') }}</p>
          </v-flex>
        </v-layout>

        <v-card flat class="transparent" height="100"></v-card>

        <!-- insert -->
        <v-layout row wrap>
          <v-flex sm4 xs12>
            <v-card>
              <v-img @contextmenu.prevent="preventRightClick" aspect-ratio="1" :src="executives.affandi"></v-img>
            </v-card>
          </v-flex>
          <v-flex offset-sm1 sm7 xs12>
            <h3 class="mb-1">{{ __('Affandi Salleh') }}</h3>
            <p><strong>{{ __('Executive Vice President & Chief Operating Officer') }}</strong></p>

            <br>
            <p>{{ __('With over a quarter century of diverse experience in management consultancy, Affandi is the Chief Operating Officer of SSA Consulting Group. His consultancy work has spanned corporate and strategic planning, industrial management, organisational development, acquisition, project management, computerisation and standardisation, procurement and negotiation, marketing, public relations, finance, accounting, ISO 9000, and human resource management.') }}</p>
          </v-flex>
        </v-layout>

        <v-card flat class="transparent" height="100"></v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import kang from '@/modules/CDA/About/assets/images/kang.png'
import zaid from '@/modules/CDA/About/assets/images/zaid.png'
import looi from '@/modules/CDA/About/assets/images/looi.png'
import suhaimi from '@/modules/CDA/About/assets/images/suhaimi.png'
import affandi from '@/modules/CDA/About/assets/images/affandi.png'

export default {
  name: 'Executives',

  data () {
    return {
      executives: {
        kang: kang,
        zaid: zaid,
        looi: looi,
        suhaimi: suhaimi,
        affandi: affandi,
      }
    }
  },

  mounted () {
    this.preventRightClick()
  },

  methods: {
    preventRightClick () {
      return false
    }
  }
}
</script>
